import React from "react";
import { VIEW_ONLY_EMPTY_MESSAGE } from "../../hooks/useAdminPermissions";
import CoiCertificateLanguageToggle from "./CoiCertificateLanguageToggle";

const CoiCertificateViewOnlyEmpty = ({ manageSwitch, setManageSwitch }) => {
  return (
    <>
      <CoiCertificateLanguageToggle
        manageSwitch={manageSwitch}
        setManageSwitch={setManageSwitch}
      />
      <p className="heedprodct mb-20">Certificate</p>
      <div className="sectionpadding bg-white mb-30 coi-view-panel">
        <p className="release-document-view-empty mb-0">
          {VIEW_ONLY_EMPTY_MESSAGE}
        </p>
      </div>
    </>
  );
};

export default CoiCertificateViewOnlyEmpty;
